export default __webpack_public_path__ + "static/media/twenty-four-seven.b03b8c87.svg";